module.exports = __webpack_public_path__ + "static/media/profile_photo_white.c8e23ff5.jpg";